/* eslint-disable react/jsx-props-no-spreading */

import FormControlLabel from 'components/Form/Control/FormControlLabel';
import React, { forwardRef } from 'react';
import { Form, Input } from 'rsuite';
// eslint-disable-next-line import/no-unresolved
import styles from './TextareaFormField.module.scss';

interface ITextFormField {
  required: boolean;
  flex?: number;
  name: string; // name of the key to map to
  helpMessage?: string; // help message to display
  label: string; // field label
  rows: number; // number of rows to render
  data: any;
  className?: any;
}

const Textarea = forwardRef((props, ref: any) => (
  <Input {...props} as="textarea" ref={ref} />
));

const TextAreaFormField = forwardRef((props: ITextFormField, ref: any) => {
  const {
    data,
    flex = undefined,
    name,
    helpMessage = undefined,
    label,
    required,
    className,
    ...rest
  } = props;

  return (
    <Form.Group
      ref={ref}
      className={[styles.formGroup, className].filter(Boolean).join(' ')}
      style={flex ? { flex: `${flex} 0 100%` } : undefined}
    >
      <FormControlLabel required={required || false}>
        {label}
      </FormControlLabel>
      <div className={styles.controlWrapper}>
        <Form.Control
          name={name}
          accepter={Textarea}
          {...rest}
          // @ts-ignore
          rows={data?.rows ?? 4}
        />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default TextAreaFormField;
